import { baseTheme } from '@instech/components';

export const theme = {
  ...baseTheme,
  /* Additional style declarations go here */
};
